import type { ServiceRequestDto } from '@smartsash/api-client';

/**
 * Whether a request offers an assignee picker (HS-1542): only an open one, and only to a caller
 * allowed `serviceRequest.assign`. Anyone else reads the assignee as text; a closed request keeps
 * the assignee it had. Kept apart from the picker so the list's initial chunk carries no more
 * than this check.
 */
export function isAssignable(request: Pick<ServiceRequestDto, 'status'>, mayAssign: boolean) {
  return mayAssign && request.status === 'New';
}
